export const styles = theme => ({
  root: {
    width: '100%',
    marginTop: '2px',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  title: {}
});

export const toolbarConfig = {
  topPager: false,
  bottomPager: true
};
